import axios from "axios";

export const loadGameList = async (): Promise<any[]> => {
  const response = await axios.get("gameList");
  return response.data;
};
